import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumAssemblyStatus implements BaseEnumType {
  private static allValues: EnumAssemblyStatus[] = []; // make sure this is top-most
  
  public static open = new EnumAssemblyStatus(0, "Open", "enum_assembly_status_open");
  public static inProgress = new EnumAssemblyStatus(1, "InProgress", "enum_assembly_status_in_progress");
  public static complete = new EnumAssemblyStatus(2, "Complete", "enum_assembly_status_complete");
  public static cancelled = new EnumAssemblyStatus(3, "Cancelled", "enum_assembly_status_cancelled");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumAssemblyStatus.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isOpen() { return this === EnumAssemblyStatus.open; }
  public isInProgress() { return this === EnumAssemblyStatus.inProgress; }
  public isComplete() { return this === EnumAssemblyStatus.complete; }
  public isCancelled() { return this === EnumAssemblyStatus.cancelled; }

  public static getValues(): readonly EnumAssemblyStatus[] {
    return EnumAssemblyStatus.allValues;
  }

  public static getValuesExcept0(): readonly EnumAssemblyStatus[] {
    return EnumAssemblyStatus.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumAssemblyStatus {
    const found = EnumAssemblyStatus.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumAssemblyStatus - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumAssemblyStatus): EnumAssemblyStatus {
    const found = name ? EnumAssemblyStatus.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumAssemblyStatus - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumAssemblyStatus>): boolean {
    return this.key === other?.key;
  }
}